var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKmjlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 46,
    viewBox: "0 0 32 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5897 26.2771L31.6098 35.0609C31.6098 45.0357 12.1074 45.0357 9.57603 45.0357C7.04466 45.0357 0.643921 46.0001 0.643921 46.0001C2.43034 29.1026 16.5734 21.5109 16.5734 21.5109L27.5897 26.2771Z",
    fill: "url(#paint0_linear_0_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5349 11.2417V35.9529C30.2969 33.5963 28.3417 31.6929 25.9526 30.5189C19.3228 27.2438 2.43016 19.2049 0.638916 0C0.638916 0 7.41211 1.19095 10.9862 1.78642C14.4143 2.30837 31.4601 2.45784 31.5349 11.2417Z",
    fill: "url(#paint1_linear_0_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_16",
    x1: 6.8988,
    y1: 33.0696,
    x2: 20.0908,
    y2: 71.1208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FED600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#956B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30130D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_16",
    x1: -10.1748,
    y1: 70.1432,
    x2: 36.6976,
    y2: 70.7543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B16B28"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmjlogo);
export default __webpack_public_path__ + "static/media/kmj logo.af5a96cb57aedb3b478e20a62e3372dc.svg";
export { ForwardRef as ReactComponent };